export const getContactOrgId = (portalsBlock) => {
  if (!portalsBlock) {
    return '';
  }

  if (portalsBlock.selectedHetPayId) {
    return portalsBlock.selectedHetPayId;
  }

  const selectedCompany = portalsBlock.privateCompanyList?.find(
    (org) => org.idNumber == portalsBlock.selectedHetPay,
  );

  return selectedCompany?.orgId?.trim() || portalsBlock.selectedHetPay || '';
};

export const ACTIVATE_NIUD_ERROR_MESSAGES = {
  SubscriberStatusIsSuspended: 'מנוי אינו פעיל (סטטוס אינו A)',
  Provider1428RelatedError: 'שגיאה בבדיקת פרטי מספר מארח',
  KosherNumberNotAllowed: 'לא ניתן לבצע פעולה על מספר כשר',
  Provider1842RelatedError: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
  Provider631RelatedError: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
  '18421': 'אין התאמה בין מספר מארח ומספר מתנייד',
  IdNumberMismatch: 'מספר הזיהוי או סוג הזיהוי אינם תואמים לפרטי המנוי',
  PhoneNumberNotFound: 'לא נמצא מנוי, אנא בדקו את הפרטים שהוזנו',
  AccountNotFound: 'מספר מארח זה לא משוייך לאחד מהארגונים שלך, אנא בדקו את הפרטים שהוזנו',
  MemberOfDifferentOrg: 'מספר מארח זה משוייך לארגון אחר מרשימת הארגונים שלך, אנא בדקו את הפרטים שהוזנו',
  OrgIdNotFound: 'ארגון לא נמצא, אנא בדקו את הפרטים שהוזנו',
  ErrorOnValidation: 'קרתה תקלה במהלך הזיהוי, אנא בדקו את הפרטים שהוזנו',
  GeneralError: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
};

const hasText = (value) => typeof value === 'string' && value.trim().length > 0;

export const getActivateNiudErrorMessage = (errorCode, serverMessage) => {
  if (hasText(serverMessage)) {
    return serverMessage;
  }

  return ACTIVATE_NIUD_ERROR_MESSAGES[errorCode] || ACTIVATE_NIUD_ERROR_MESSAGES.GeneralError;
};

export const getActivateNiudSuccessMessage = (serverMessage, formattedPortTime) => {
  if (hasText(serverMessage)) {
    return serverMessage;
  }

  return buildActivateNiudSuccessMessage(formattedPortTime);
};

export const buildActivateNiudSuccessMessage = (formattedPortTime) => {
  const statusLine = 'לבירור סטטוס ניוד ניתן להיכנס בכל עת לפעולת בדיקת סטטוס ניוד.';

  if (!formattedPortTime) {
    return `בקשת הניוד יצאה לדרך.\n${statusLine}`;
  }

  return `בקשת הניוד יצאה לדרך.\nזמן ניוד משוער ${formattedPortTime}.\n${statusLine}`;
};

export const formatExpectedPortTime = (expectedPortTime) => {
  if (!expectedPortTime) {
    return '';
  }

  const parsed = new Date(expectedPortTime);
  if (Number.isNaN(parsed.getTime())) {
    return expectedPortTime;
  }

  const day = String(parsed.getDate()).padStart(2, '0');
  const month = String(parsed.getMonth() + 1).padStart(2, '0');
  const year = parsed.getFullYear();
  const hours = String(parsed.getHours()).padStart(2, '0');
  const minutes = String(parsed.getMinutes()).padStart(2, '0');

  return `${day}.${month}.${year} ${hours}:${minutes}`;
};
